import { ReactNode } from 'react'

interface PolicySectionTitleProps {
  children: ReactNode
}

export const PolicySectionTitle = ({ children }: PolicySectionTitleProps) => (
  <h2 className="text-4xl font-archivo font-black text-blue mb-7">
    {children}
  </h2>
)
